import { SERIF, SANS, MONO, todayTokens } from './todayTokens';

/** Shared Today chrome for property-details dialogs. */
export function todayDialog(isDarkMode, { fullScreen = false } = {}) {
  const tk = todayTokens(isDarkMode);
  const focusRing = { '&.Mui-focusVisible': { outline: `2px solid ${tk.navy}`, outlineOffset: '2px' } };
  const outlineBtn = {
    minHeight: 40,
    px: 1.75,
    borderRadius: '10px',
    fontFamily: SANS,
    fontSize: 13,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    bgcolor: tk.surface,
    color: tk.ink,
    border: `1px solid ${tk.lineStrong}`,
    '&.Mui-disabled': { opacity: 0.45 },
    ...focusRing,
  };
  return {
    tk,
    SERIF,
    SANS,
    MONO,
    paper: {
      borderRadius: fullScreen ? 0 : '18px',
      bgcolor: tk.surface,
      color: tk.ink,
      border: `1px solid ${tk.line}`,
      backgroundImage: 'none',
      overflow: 'hidden',
    },
    title: {
      px: { xs: 2.5, md: 3 },
      pt: { xs: 2.5, md: 3 },
      pb: 2,
      borderBottom: `1px solid ${tk.lineSoft}`,
    },
    h2: {
      m: 0,
      fontFamily: SERIF,
      fontSize: { xs: 24, md: 28 },
      fontWeight: 400,
      lineHeight: 1.2,
      color: tk.ink,
    },
    eyebrow: {
      display: 'block',
      fontFamily: MONO,
      fontSize: 11,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: tk.muted,
      mb: 0.75,
    },
    body: { fontSize: 14, color: tk.body, lineHeight: 1.5 },
    section: {
      p: 2.5,
      mb: 2.5,
      borderRadius: '14px',
      bgcolor: tk.surfaceAlt,
      border: `1px solid ${tk.line}`,
    },
    selectRow: (selected) => ({
      p: 2,
      borderRadius: '12px',
      border: `1px solid ${selected ? tk.navy : tk.line}`,
      bgcolor: selected ? (isDarkMode ? 'rgba(143,163,224,0.1)' : 'rgba(28,43,90,0.04)') : tk.surface,
      cursor: 'pointer',
      transition: 'border-color 0.15s ease, background-color 0.15s ease',
      '&:hover': { borderColor: tk.navy },
    }),
    chip: {
      height: 24,
      fontFamily: SANS,
      fontSize: 11,
      fontWeight: 600,
      bgcolor: tk.surfaceAlt,
      color: tk.muted,
      border: `1px solid ${tk.lineStrong}`,
    },
    closeBtn: {
      flexShrink: 0,
      width: 36,
      height: 36,
      borderRadius: '10px',
      border: `1px solid ${tk.lineStrong}`,
      color: tk.ink,
      '&:hover': { bgcolor: tk.surfaceAlt },
      '&:disabled': { opacity: 0.5 },
    },
    actions: {
      px: { xs: 2.5, md: 3 },
      py: 2.5,
      gap: 1.5,
      borderTop: `1px solid ${tk.lineSoft}`,
      bgcolor: tk.surface,
    },
    outlineBtn,
    primaryBtn: {
      ...outlineBtn,
      bgcolor: tk.navy,
      color: isDarkMode ? tk.panelText : '#fff',
      border: 0,
      '&:hover': { bgcolor: tk.navy, opacity: 0.92 },
    },
    rustBtn: {
      ...outlineBtn,
      bgcolor: tk.rust,
      color: '#fff',
      border: 0,
      '&:hover': { bgcolor: tk.rust, opacity: 0.92 },
    },
    rustOutlineBtn: {
      ...outlineBtn,
      color: tk.rust,
      border: `1px solid ${tk.rust}`,
      '&:hover': { bgcolor: isDarkMode ? 'rgba(240,113,74,0.12)' : 'rgba(185,58,18,0.06)' },
    },
    checkbox: {
      color: tk.lineStrong,
      '&.Mui-checked': { color: tk.navy },
    },
  };
}
